import React from 'react';
import classNames from 'classnames';
import { HelpSquareIcon } from '@hugeicons/core-free-icons';
import { HugeIcon } from './icons/HugeIcon';
import ICON_MAP, { SOLID_ICON_NAMES } from './icons/iconMap';

const getIconSize = size => {
  if (size === 'small') return '8px';
  if (size === 'semi-small') return '10px';
  if (size === 'medium') return '12px';
  if (size === 'large') return '18px';
  return '15px';
};

const COLOR_VALUES = {
  primary: 'var(--primary-Color)',
  white: '#ffffff',
};

// Names whose glyph carries its own meaning colour (status, destructive, brand accents).
// Applied only when the caller does not ask for a colour.
const DESTRUCTIVE = 'var(--destructive)';
const SUCCESS = 'var(--success)';
const PRIMARY = 'var(--primary-Color)';

const NAME_COLORS = {
  DeleteOutlined: DESTRUCTIVE,
  InfoCircleOutlinedRed: DESTRUCTIVE,
  LockOutlined: DESTRUCTIVE,
  MinusInCircleoutlined: DESTRUCTIVE,
  PauseOutlined: DESTRUCTIVE,
  CheckCircleOutlined: SUCCESS,
  PlayFilled: SUCCESS,
  PlayOutlined: SUCCESS,
  ReferenceActiveOutlined: SUCCESS,
  PauseFilled: 'var(--warning)',
  AIIcon: PRIMARY,
  ResumeFilled: PRIMARY,
  FaqGuideline: PRIMARY,
  ChatFilled: PRIMARY,
  FallbackFilled: PRIMARY,
  ListenFilled: PRIMARY,
  ShieldFilled: PRIMARY,
  LocationOutlined: '#fafafa',
  PlayVideoOutlined: '#fafafa',
  facebookOutlined: '#1877f2',
};

/**
 * Shared icon. Renders a Hugeicon by name, sized like the previous SVG icons.
 * `color="black"` (default) follows the surrounding text colour, so it adapts to dark mode.
 */
function Icon({ name, size = 'middle', style = {}, className = '', color = 'black', onClick }) {
  const icon = ICON_MAP[name];

  if (!icon && process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.warn(`[Icon] No Hugeicon mapped for "${name}"`);
  }

  const width = style.width || getIconSize(size);
  const iconColor = COLOR_VALUES[color] || (color === 'black' ? NAME_COLORS[name] : undefined);

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <HugeIcon
      icon={icon || HelpSquareIcon}
      solid={SOLID_ICON_NAMES.has(name)}
      onClick={handleClick}
      aria-label={name}
      // Named icons are sized by their box, not by inherited font-size
      className={classNames('icon [&>svg]:size-full!', className)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        fontSize: width,
        width,
        height: style.height || width,
        lineHeight: 0,
        ...(iconColor ? { color: iconColor } : {}),
        ...style,
      }}
    />
  );
}

export default Icon;
